import { render, staticRenderFns } from "./total_expand.vue?vue&type=template&id=81dfe332&scoped=true"
import script from "./total_expand.vue?vue&type=script&lang=js"
export * from "./total_expand.vue?vue&type=script&lang=js"
import style0 from "./total_expand.vue?vue&type=style&index=0&id=81dfe332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dfe332",
  null
  
)

export default component.exports